import { useEffect, useState } from "react";
import { RadioGroup } from "@headlessui/react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function RadioGroupInput({
  options = [],
  onSelect,
  preselected,
  srLabel = "Radio Group Input"
}) {
  const [selected, setSelected] = useState();

  const handleChange = (selectedOption) => {
    setSelected(selectedOption);
    if (onSelect) {
      onSelect(selectedOption.id || selectedOption);
    }
  };

  useEffect(() => {
    const selectedOption = options.find(
      (option) => option.id === preselected || option === preselected
    );
    if (selectedOption) setSelected(selectedOption?.id || selectedOption);
  }, [preselected]);

  return (
    <RadioGroup value={selected?.id || selected} onChange={handleChange}>
      <RadioGroup.Label className="sr-only">{srLabel}</RadioGroup.Label>
      <div className="relative grid grid-cols-2 gap-4 my-2">
        {options.map((option) => {
          return (
            <RadioGroup.Option
              key={option.id}
              value={option.id || option}
              className={({ checked, active }) =>
                classNames(
                  checked || active ? "bg-[#E3E3E3]" : "bg-white",
                  "z-10 sm:grow relative flex cursor-pointer flex-col border p-4 focus:outline-none md:pl-4 rounded-full items-center justify-center"
                )
              }>
              {({ active, checked }) => (
                <>
                  <span className="flex items-center text-sm">
                    {/* <span
                      className={classNames(
                        checked || active ? `border-2 border-black` : "border-1 border-black",
                        "h-4 w-4 rounded-full border flex items-center justify-center bg-transparent"
                      )}
                      aria-hidden="true"></span> */}
                    <RadioGroup.Label
                      as="span"
                      className={classNames(
                        checked || active ? "text-cblack-300" : "text-gray-900",
                        "ml-3 font-medium"
                      )}>
                      {option.name}
                    </RadioGroup.Label>
                  </span>
                  <RadioGroup.Description
                    as="span"
                    className={classNames(
                      checked || active ? "text-cblack-100" : "text-gray-500",
                      "text-sm text-center"
                    )}>
                    {option.description}
                  </RadioGroup.Description>
                </>
              )}
            </RadioGroup.Option>
          );
        })}
      </div>
    </RadioGroup>
  );
}
